const fiveThreeSchema = {
  title: "5_3 End of Life Stage of the Product",
  addAPI: "cat5_3AddEmissionActivityAPI",
  cat: "cat5_3",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Waste Management Vendor Name",
      resetOnChange: false,
      required: true,
    },
    //////// Method of Calculation
    {
      key: "calculationId",
      level: 1,
      type: "select",
      label: "Method of Calculation",
      optionsAPI: "cat5Calculation",
      optionsParamFrom: {
        value: "5_3",
      },
      required: true,
    },
  ],
};
export default fiveThreeSchema;
